import React from 'react';
import { ReactComponent as Clock } from '../../assets/images/icons/clock.svg';

export default function ClockIcon(props) {
  return (
    <Clock className={`icon ${props.className}`} />
  );
}
